export const messages = {
  en: {
    housekeepingTypeManage: {
      queryCondition: 'Query Condition',
      inputTypeName: 'Please input type name',
      selectShowStatus: 'Please select show status',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      query: 'Query',
      housekeepingMenu: 'Housekeeping Menu',
      add: 'Add',
      smallIcon: 'Small Icon',
      menuName: 'Menu Name',
      menuDesc: 'Menu Description',
      label: 'Label',
      sort: 'Sort',
      isShow: 'Is Show',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addHousekeepingType: {
      add: 'Add',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      smallIcon: 'Small Icon',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input service description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      skipType: 'Skip Type',
      selectSkipType: 'Required, please select skip type',
      normalProduct: 'Normal Product',
      internal: 'Internal',
      external: 'External',
      shop: 'Shop',
      singleProduct: 'Single Product',
      inputUrl: 'Optional, please input URL',
      internalUrlTip: 'Please use browser to open mobile mall, copy all addresses after #',
      externalUrlTip: 'Input complete external address, need to add http or https',
      selectShop: 'Select Shop',
      selectProduct: 'Select Product',
      inputSort: 'Required, please input sort',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      save: 'Save',
      cancel: 'Cancel',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      validate: {
        menuNameRequired: 'Menu name is required',
        iconRequired: 'Small icon is required',
        sortRequired: 'Sort is required',
        showStatusRequired: 'Show status is required',
        skipTypeRequired: 'Skip type is required',
        shopRequired: 'Shop is required',
        productRequired: 'Product is required'
      }
    },
    editHousekeepingType: {
      edit: 'Edit',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      smallIcon: 'Small Icon',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input service description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      skipType: 'Skip Type',
      selectSkipType: 'Required, please select skip type',
      normalProduct: 'Normal Product',
      internal: 'Internal',
      external: 'External',
      shop: 'Shop',
      singleProduct: 'Single Product',
      inputUrl: 'Optional, please input URL',
      internalUrlTip: 'Please use browser to open mobile mall, copy all addresses after #',
      externalUrlTip: 'Input complete external address, need to add http or https',
      selectShop: 'Select Shop',
      selectProduct: 'Select Product',
      inputSort: 'Required, please input sort',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      save: 'Save',
      cancel: 'Cancel',
      updateSuccess: 'Update successfully',
      updateFailed: 'Update failed',
      validate: {
        menuNameRequired: 'Menu name is required',
        iconRequired: 'Small icon is required',
        sortRequired: 'Sort is required',
        showStatusRequired: 'Show status is required',
        idRequired: 'ID is required',
        skipTypeRequired: 'Skip type is required',
        shopRequired: 'Shop is required',
        productRequired: 'Product is required'
      }
    },
    deleteHousekeepingType: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteService: 'Confirm to delete service',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    },
    uploadImage: {
      fileSizeLimit: 'Image size cannot exceed 2MB'
    }
  },
  zh: {
    housekeepingTypeManage: {
      queryCondition: '查询条件',
      inputTypeName: '请输入类别名称',
      selectShowStatus: '请选择是否展示',
      all: '全部',
      yes: '是',
      no: '否',
      query: '查询',
      housekeepingMenu: '家政菜单',
      add: '添加',
      smallIcon: '小图标',
      menuName: '菜单名称',
      menuDesc: '菜单描述',
      label: '标签',
      sort: '排序',
      isShow: '是否显示',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addHousekeepingType: {
      add: '添加',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      smallIcon: '小图标logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      skipType: '跳转类型',
      selectSkipType: '必填，请选择跳转类型',
      normalProduct: '普通商品',
      internal: '站内',
      external: '站外',
      shop: '店铺',
      singleProduct: '单个商品',
      inputUrl: '选填，请填写URL',
      internalUrlTip: '请使用浏览器打开手机商城，复制#号已后的全部地址',
      externalUrlTip: '输入外部完整地址，需加上http或者https',
      selectShop: '选择店铺',
      selectProduct: '选择商品',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      save: '保存',
      cancel: '取消',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      validate: {
        menuNameRequired: '菜单名称不能为空',
        iconRequired: '小图标不能为空',
        sortRequired: '排序不能为空',
        showStatusRequired: '是否显示不能为空',
        skipTypeRequired: '跳转类型不能为空',
        shopRequired: '请选择店铺',
        productRequired: '请选择商品'
      }
    },
    editHousekeepingType: {
      edit: '修改',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      smallIcon: '小图标logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      skipType: '跳转类型',
      selectSkipType: '必填，请选择跳转类型',
      normalProduct: '普通商品',
      internal: '站内',
      external: '站外',
      shop: '店铺',
      singleProduct: '单个商品',
      inputUrl: '选填，请填写URL',
      internalUrlTip: '请使用浏览器打开手机商城，复制#号已后的全部地址',
      externalUrlTip: '输入外部完整地址，需加上http或者https',
      selectShop: '选择店铺',
      selectProduct: '选择商品',
      inputSort: '必填，请填写排序',
      isShow: '是否显示',
      selectShowStatus: '必填，请选择是否显示',
      save: '保存',
      cancel: '取消',
      updateSuccess: '修改成功',
      updateFailed: '修改失败',
      validate: {
        menuNameRequired: '菜单名称不能为空',
        iconRequired: '小图标不能为空',
        sortRequired: '排序不能为空',
        showStatusRequired: '是否显示不能为空',
        idRequired: '服务ID不能为空',
        skipTypeRequired: '跳转类型不能为空',
        shopRequired: '请选择店铺',
        productRequired: '请选择商品'
      }
    },
    deleteHousekeepingType: {
      confirmOperation: '请确认您的操作',
      confirmDeleteService: '确定删除服务',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    uploadImage: {
      fileSizeLimit: '图片大小不能超过2MB'
    }
  }
}